export const GREETING_TITLE = 'How can I help you today?';

export const DEFAULT_GREETING_MESSAGE =
  "I'm Nova Assist, your AI assistant at Newfront. Ask me insurance questions, upload documents to analyze, or get help with calculations and communications.";
